import React, {Component} from "react";
import * as prosConnect from "../prodect/ProsConnect"
import {
    ATTR_TEXT,
    ATTR_OBJ_ID,
    ATTR_CUSTOMER_GROUP,
    ATTR_USER_ROLE,
    ROLE_ADMIN,
    ATTR_AWS_PROJECT_ID
} from "../prodect/ProsConnect";
import {isShowingHelpDesk, setHelpContext} from "../prodect/HelpManager";
import LoadingAnimation from "../components/LoadingAnimation";
import CreateMainProject from "./CreateMainProject";
import PermissionManagement from "./PermissionManagement";
import {CustomerUsers} from "./CustomerUsers";
import {CustomerPdfFrontpages} from "./CustomerPdfFrontpages";
import BasicButton from "../components/BasicButton";
import {CustomerEnums} from "./CustomerEnums";
const PAGE_CUST_SETTINGS = 'settings'
const PAGE_CUST_USERS = 'cust_users'
const PAGE_CUST_PG = 'cust_perm_groups'
const PAGE_CUST_PDF_FRONTPAGES = 'cust_frontpages'
const PAGE_CUST_ENUMS = 'cust_enums'


export default class CustomerSettings extends Component {

    constructor(props) {
        super(props);
        this.state = {
            customers: undefined,
            loading: false,
            showHelpDesk: isShowingHelpDesk(),
            activeCustomer: null,
            activePage: PAGE_CUST_SETTINGS,
            selectedCustomerAdminSubProjectId: undefined
        }
    }

    async componentDidMount() {
        setHelpContext('settings')
        await this.loadCustomers()
    }

    goBack() {
        this.props.closeView()
    }

    async loadCustomers() {
        let customers = await prosConnect.getCustomers()
        if (customers) {
            this.setState({
                customers: customers
            })
            if(!this.state.activeCustomer) this.setActiveCustomer(customers[0])
        }
    }

    renderHelpDeskControl(){
        return <li>
            <BasicButton
                label={"Näytä ohje"}
                icon={"help"}
                action={()=>{
                    this.props.toggleShowingHelpDesk()
                }}
                selected={this.props.showHelpDesk}
                hilite={this.props.showHelpDesk}
                shrink={"md"}
            />
        </li>
    }

    setActiveCustomer(customer) {
        if (this.state.activeCustomer === customer && this.state.activePage === PAGE_CUST_SETTINGS) {
            return
        }
        let activeCustomerId = customer[ATTR_OBJ_ID]
        let firstAdminSubproject = prosConnect
            .getCurrentProjectList()
            .find(proj => proj[ATTR_CUSTOMER_GROUP] === activeCustomerId &&
                proj[ATTR_USER_ROLE] === ROLE_ADMIN)
        this.setState({
            activeCustomer: customer,
            activePage: PAGE_CUST_SETTINGS,
            selectedCustomerAdminSubProjectId: firstAdminSubproject ?
                firstAdminSubproject[ATTR_AWS_PROJECT_ID] : undefined
        })
    }

    setActivePage(page) {
        if (page === this.state.activePage) {
            return
        }
        // todo get customer perms etc
        this.setState({
            activePage: page,
            //activeCustomer: this.state.activeCustomer
        })
        switch(page) {
            case PAGE_CUST_SETTINGS: setHelpContext('settings'); break
            case PAGE_CUST_USERS: setHelpContext('customerUsageInfo'); break
            case PAGE_CUST_PG: setHelpContext('settings'); break
            case PAGE_CUST_PDF_FRONTPAGES: setHelpContext('customer-pdf-page'); break
            case PAGE_CUST_ENUMS: setHelpContext('customer-enum-list'); break
            default: setHelpContext('settings'); break
        }
    }

    renderCustomerList(){
        if (this.state.customers === undefined) {
            return <LoadingAnimation color={"var(--color-gray-40)"} />
        }
        if(this.state.customers?.length < 1) return <p className={"color-2nd text-center"}>Ei asiakkaita.</p>
        let customers = this.state.customers.map(customer =>{
            let isActiveCustomer = customer === this.state.activeCustomer
            return <li key={customer.obj_id}>
                <BasicButton
                    label={customer[ATTR_TEXT]}
                    icon={"chevron-right"}
                    action={()=>{
                        this.setActiveCustomer(customer)
                    }}
                    selected={isActiveCustomer}
                    hilite={isActiveCustomer}
                    shrink={"md"}
                />
            </li>
        })
        return customers
    }

    renderCreateMainProject() {
        if (!this.state.activeCustomer) {
            return <LoadingAnimation size={"lg"} />
        }
        let customerAndProject = {
            customerGroup: this.state.activeCustomer.obj_id,
            mainProjectName: ""
        }
        return <CreateMainProject
            switchToReportView={this.switchToReportView}
            isMakingNewProject={false}
            customerAndProject={customerAndProject}
            isEditCustomerMode={true}
            refreshCustomerList={()=> this.loadCustomers()}
        />
    }

    renderUsageStats(){
        if (!this.state.activeCustomer) {
            return <h2>Asiakasta ei ole valittu</h2>
        }
        let activeCustomerId = this.state.activeCustomer[ATTR_OBJ_ID]
        return <>
            <section>
                <CustomerUsers customerId={activeCustomerId}/>
            </section>
        </>
    }

    renderCustomerPdfFrontpages(){
        if (!this.state.activeCustomer) {
            return <h2>Asiakasta ei ole valittu</h2>
        }
        let activeCustomerId = this.state.activeCustomer[ATTR_OBJ_ID]
        return <>
            <section>
                <CustomerPdfFrontpages parentNode={this} customerId={activeCustomerId}/>
            </section>
        </>
    }

    renderCustomerEnums(){
        if (!this.state.activeCustomer) {
            return <h2>Asiakasta ei ole valittu</h2>
        }
        let activeCustomerId = this.state.activeCustomer[ATTR_OBJ_ID]
        return <>
            <section>
                <CustomerEnums parentNode={this} customerId={activeCustomerId}/>
            </section>
        </>
    }

    renderPermissionGroups(){
        let permissionView = this.state.selectedCustomerAdminSubProjectId ?
            <PermissionManagement
                closePage={() => this.setActivePage(PAGE_CUST_SETTINGS)}
                showSingleSubProject={false}
                showGroupsOnly={true}
                subProjectId={this.state.selectedCustomerAdminSubProjectId}
            /> :
            <>
                <h1>Osaprojekti puuttuu</h1>
                <p>Käyttöoikeusryhmän määrittämiseen tarvitaan vähintään yksi osaprojekti</p>
            </>
        return <>
            <section>
                {permissionView}
            </section>
        </>
    }

    renderHeaderMainButton(page, icon, tabIndex, title) {
        const isSelected = this.state.activePage === page
        return <BasicButton
                icon={icon}
                iconColor={isSelected ? "light" : null}
                action={() => this.setActivePage(page)}
                selected={isSelected}
                tabIndex={tabIndex}
            >
            <div className={"text-center text-xs"}>{title}</div>
        </BasicButton>
    }

    renderMainTitle() {
        const title = this.state.activeCustomer ? this.state.activeCustomer[ATTR_TEXT] : 'Asiakkaat'
        return <h1>{title}</h1>
    }

    renderMainHeader() {
        return <header className="page-header">
            {this.renderMainTitle()}
            <nav className={"nav-page-header"}>
                <div className={"btn-set"}>
                    {this.renderHeaderMainButton(PAGE_CUST_SETTINGS, "gear", "1", "Asetukset")}
                    {this.renderHeaderMainButton(PAGE_CUST_PG, "group", "2", "Käyttöoikeusryhmät")}
                    {this.renderHeaderMainButton(PAGE_CUST_PDF_FRONTPAGES, "document-text", "4", "PDF-etusivut")}
                    {this.renderHeaderMainButton(PAGE_CUST_ENUMS, "check-list", "5", "Valintalistat")}
                    {this.renderHeaderMainButton(PAGE_CUST_USERS, "stats", "3", "Käyttötiedot")}
                </div>
            </nav>
        </header>
    }

    renderContent() {
        switch(this.state.activePage) {
            case PAGE_CUST_SETTINGS: return this.renderCreateMainProject()
            case PAGE_CUST_USERS: return this.renderUsageStats()
            case PAGE_CUST_PG: return this.renderPermissionGroups()
            case PAGE_CUST_PDF_FRONTPAGES: return this.renderCustomerPdfFrontpages()
            case PAGE_CUST_ENUMS: return this.renderCustomerEnums()
            default: return <h2>{"ERR no render for page:" + this.state.activePage}</h2>
        }
    }

    render() {
        require("./assets/scss/CustomerSettings.scss")
        return <>
            {this.renderMainHeader()}
            <div className={"side-nav-container"}>
                <nav className={"side-nav"}>
                    <ul className={"navigation"}>
                        <li>
                            <BasicButton
                                label={"Alkuun"}
                                icon={"arrow-left"}
                                action={() => {
                                    this.goBack()
                                }}
                                shrink={"md"}
                            />
                        </li>
                        {this.renderHelpDeskControl()}
                        {this.renderCustomerList()}
                    </ul>
                </nav>
                <div className={"side-nav-page"}>{this.renderContent()}</div>
            </div>
        </>
    }
}